import React from 'react';
import {MenuItemRendererBase} from "../../../menu-items-common/renderer/menu-item-renderer-base";
import {
    IMenuItemConfigReader
} from "../../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {IRenderMenuItemOptions} from "../../../menu-items-common/renderer/menu-item.renderer.interface";
import {MichiganSportSideMenuItemComponent} from "./components/michigan.sport-side-menu-item.component";

export class MichiganSportSideMenuItemRenderer extends MenuItemRendererBase {
    constructor( configReader: IMenuItemConfigReader,
                 services: IServiceFactoryExtended) {
        super('sportCrossBrandMenuItem', configReader, services);
    }

    protected _createReactElement(options?: IRenderMenuItemOptions): React.ReactElement {
        return (<MichiganSportSideMenuItemComponent key={this.key} menuItem={this}/>);
    }
}